import { useTranslation } from "next-i18next";
import { FunctionComponent } from "react";

import styles from "./ScorePastille.module.scss";

import { getScoreAsText, selectColor } from "@lib/helper/scoreUtils";

export interface IScoreProps {
  value?: number;
  withText?:
    | boolean
    | {
        position: "right" | "left";
      };
}

const ScorePastille: FunctionComponent<IScoreProps> = ({ value, withText = false }) => {
  const { t } = useTranslation("common");
  if (value === undefined) return <></>;

  const textPosition = withText === false ? undefined : withText === true ? "right" : withText.position;
  const text = getScoreAsText(value, t);

  const roundedValue = Math.round(value);
  const colorClassName = styles[`score-pastille__dot${selectColor(roundedValue)}`];
  return (
    <div className={styles["score-pastille"]}>
      {textPosition && textPosition === "left" && <div className={styles["score-pastille__text"]}>{text}</div>}
      <div className={`${styles["score-pastille__dot"]} ${colorClassName}`}></div>
      {textPosition && textPosition === "right" && <div className={styles["score-pastille__text"]}>{text}</div>}
    </div>
  );
};

export default ScorePastille;
